import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map'
import { Observable } from 'rxjs/Observable';
import { Configuration } from '../app.constants';
import { FirmwareAsset } from '../admin/models/firmwareasset';
import { ApiResponse } from '../admin/apiresponse';
import { AdalHttp } from './adal.http.service';
import { EventHttpService } from './event.http.service'

@Injectable()
export class AssetService {

    private actionUrl: string;
    private headers: Headers;
    private apiResponse: ApiResponse;

    constructor(private _http: AdalHttp, private _configuration: Configuration) {

        this.actionUrl = _configuration.ServerWithApiUrl + 'asset/';

        this.headers = new Headers();
        this.headers.append('Content-Type', 'application/json');
        //this.headers.append('Accept', 'application/json');
    }

    public GetAll = (): Observable<any> => {
        return this._http.get(this.actionUrl);
//.map((response: Response) => <any>response.json()).catch(this.handleError);
    }

    public GetAllSystemTypes = (): Observable<any> => {
        return this._http.get(this.actionUrl, { headers: this.headers });
        //.map((response: Response) => <any>response.json()).catch(this.handleError);;
    }


    public GetAssetsByDeviceType = (deviceType: string): Observable<any> => {
        return this._http.get(this.actionUrl + deviceType, { headers: this.headers });
            //.map(this.extractApiResponse)
            //.catch(this.handleError);
    }

    public GetSingle = (id: number): Observable<Response> => {
        return this._http.get(this.actionUrl + id);
        //.map(res => res.json());
    }

    public Add = (itemName: string): Observable<Response> => {
        var toAdd = JSON.stringify({ ItemName: itemName });

        return this._http.post(this.actionUrl, toAdd, { headers: this.headers }).map(res => res.json());
    }

    public Update = (id: number, systemType: string, itemToUpdate: any): Observable<Response> => {
        var actionUrl = `${this.actionUrl}/${systemType}/${itemToUpdate.AssetType}/${itemToUpdate.Version}/`;
        return this._http
            .put(actionUrl, JSON.stringify(itemToUpdate), { headers: this.headers })
            .map(res => res.json());
    }

    public Delete = (deviceType: string, assetType: string, version: string): Observable<any> => {
        return this._http.delete(this.actionUrl + deviceType + '/' + assetType + '/' + version);
            //.map(this.extractApiResponse)
            //.catch(this.handleError);
    }

    xhr: XMLHttpRequest = new XMLHttpRequest();

    //NOT Used, need to remove OR Ng2FileUpload to be moved to here.
    public uploadAsset = (firmwareAsset, file) => {
        //let body = JSON.stringify(firmwareAsset);
        //let headers = new Headers({
        //    'Content-Type': false, 'enctype': 'multipart/form-data' });
        //let options = new RequestOptions({ headers: headers });

        let headers = new Headers({ 'Content-Type': undefined });
        let options = new RequestOptions({
            headers: headers
            //processData: false,
            //c
        });

        var fd = new FormData();
        fd.append('DeviceType', firmwareAsset.devicetype);
        fd.append('AssetType', firmwareAsset.assettype);
        fd.append('Version', firmwareAsset.version);
        fd.append('CompatibleVersions', firmwareAsset.compatibleversions);
        fd.append('VerificationCode', firmwareAsset.verificationcode);
        fd.append('Priority', firmwareAsset.priority);
        fd.append('file', file);

        this.xhr.open('POST', this.actionUrl, true);
        this.xhr.send(fd);
        
    }
}


// WEBPACK FOOTER //
// ./app/services/asset.service.ts